import { Currency } from '@/core/currency/interfaces';

const QAR: Currency = {
    name: 'Qatari Riyal',
    demonym: 'Qatari',
    majorSingle: 'Riyal',
    majorPlural: 'Riyals',
    codeNumeric: '634',
    symbol: 'QR',
    symbolNative: 'ر.ق.',
    minorSingle: 'Dirham',
    minorPlural: 'Dirhams',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'QAR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default QAR;
